import React, { useContext, useState } from 'react';
import { IntlProvider } from 'react-intl';
import messages from '../../locale/Locale';
import { Languages } from '../../constants/Constants';
const local = navigator.language.split(/[-_]/)[0];

// type LanguageContextInterface = {
//     locale: string;
//     // eslint-disable-next-line no-unused-vars
//     selectLanguage: (value: string) => void;
// }

const LanguageContext = React.createContext({ getSelectLanguage: () => {}, selectLanguage: (value: string) => {}});

export const useLanguageContext = () => {
    const ctx = useContext(LanguageContext);
    return ctx;
};

const LanguageWrapper = (props: { children: any }) => {
    const [locale, setLocale] = useState<any>(localStorage.getItem('language') ? localStorage.getItem('language') : (Languages.find(ele => ele.key === local) ? local : Languages[0].key));

    const selectLanguage = (value: string) => {
        const newLocale = value;
        localStorage.setItem('language', value);
        setLocale(newLocale);
    };
    const getSelectLanguage = () => {
        return locale;
    };
    return (
        <LanguageContext.Provider value={{ getSelectLanguage, selectLanguage }}>
            <IntlProvider messages={messages[locale]} locale={locale}>
                {props.children}
            </IntlProvider>
        </LanguageContext.Provider>
    );
};
export default LanguageWrapper;
